/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompanyPartyDetailsViewModel } from './CompanyPartyDetailsViewModel';
import {
    CompanyPartyDetailsViewModelFromJSON,
    CompanyPartyDetailsViewModelFromJSONTyped,
    CompanyPartyDetailsViewModelToJSON,
} from './CompanyPartyDetailsViewModel';
import type { ContactDetailsViewModel } from './ContactDetailsViewModel';
import {
    ContactDetailsViewModelFromJSON,
    ContactDetailsViewModelFromJSONTyped,
    ContactDetailsViewModelToJSON,
} from './ContactDetailsViewModel';
import type { ContactPersonViewModel } from './ContactPersonViewModel';
import {
    ContactPersonViewModelFromJSON,
    ContactPersonViewModelFromJSONTyped,
    ContactPersonViewModelToJSON,
} from './ContactPersonViewModel';
import type { OrganisationAddressesViewModel } from './OrganisationAddressesViewModel';
import {
    OrganisationAddressesViewModelFromJSON,
    OrganisationAddressesViewModelFromJSONTyped,
    OrganisationAddressesViewModelToJSON,
} from './OrganisationAddressesViewModel';

/**
 * 
 * @export
 * @interface CompanyDetailsViewModel
 */
export interface CompanyDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailsViewModel
     */
    partyId: number;
    /**
     * 
     * @type {CompanyPartyDetailsViewModel}
     * @memberof CompanyDetailsViewModel
     */
    policyHolderDetails?: CompanyPartyDetailsViewModel;
    /**
     * 
     * @type {ContactPersonViewModel}
     * @memberof CompanyDetailsViewModel
     */
    contactPerson?: ContactPersonViewModel;
    /**
     * 
     * @type {ContactDetailsViewModel}
     * @memberof CompanyDetailsViewModel
     */
    contactDetails?: ContactDetailsViewModel;
    /**
     * 
     * @type {OrganisationAddressesViewModel}
     * @memberof CompanyDetailsViewModel
     */
    addresses?: OrganisationAddressesViewModel;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDetailsViewModel
     */
    isComplete: boolean;
}

/**
 * Check if a given object implements the CompanyDetailsViewModel interface.
 */
export function instanceOfCompanyDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partyId" in value;
    isInstance = isInstance && "isComplete" in value;

    return isInstance;
}

export function CompanyDetailsViewModelFromJSON(json: any): CompanyDetailsViewModel {
    return CompanyDetailsViewModelFromJSONTyped(json, false);
}

export function CompanyDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': json['PartyId'],
        'policyHolderDetails': !exists(json, 'PolicyHolderDetails') ? undefined : CompanyPartyDetailsViewModelFromJSON(json['PolicyHolderDetails']),
        'contactPerson': !exists(json, 'ContactPerson') ? undefined : ContactPersonViewModelFromJSON(json['ContactPerson']),
        'contactDetails': !exists(json, 'ContactDetails') ? undefined : ContactDetailsViewModelFromJSON(json['ContactDetails']),
        'addresses': !exists(json, 'Addresses') ? undefined : OrganisationAddressesViewModelFromJSON(json['Addresses']),
        'isComplete': json['IsComplete'],
    };
}

export function CompanyDetailsViewModelToJSON(value?: CompanyDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'PolicyHolderDetails': CompanyPartyDetailsViewModelToJSON(value.policyHolderDetails),
        'ContactPerson': ContactPersonViewModelToJSON(value.contactPerson),
        'ContactDetails': ContactDetailsViewModelToJSON(value.contactDetails),
        'Addresses': OrganisationAddressesViewModelToJSON(value.addresses),
        'IsComplete': value.isComplete,
    };
}

